<template>
    <ion-page class="ion-page">
        <ion-header no-border translucent>
            <ion-toolbar>
                <slot name="header"></slot>
                <ion-buttons slot="start">
                    <ion-button
                        v-if="
                            showDashboardButton ||
                            (capacitor.platform === 'android' &&
                                historyLength === 1)
                        "
                        @click="$router.push({ name: 'dashboard' })"
                        color="dark"
                    >
                        <ion-icon slot="icon-only" name="arrow-back">
                        </ion-icon>
                    </ion-button>
                    <ion-back-button
                        color="dark"
                        text=""
                        :default-href="defaultHref"
                        v-else-if="showBackButton"
                    ></ion-back-button>
                    <ion-button
                        v-else-if="showStepBackButton"
                        @click="$emit('step-back')"
                        color="dark"
                    >
                        <ion-icon slot="icon-only" name="arrow-back">
                        </ion-icon>
                    </ion-button>

                    <!-- <ion-button
            color="dark"
            @click="logout('/login')"
            v-else-if="$store.state.isLoggedIn"
          >
            <ion-icon
              slot="icon-only"
              ios="md-exit"
              md="md-exit"
            ></ion-icon>
          </ion-button> -->
                    <!-- <ion-menu-button v-else></ion-menu-button> -->
                </ion-buttons>
                <ion-title
                    v-if="
                        $store.state.isLoggedIn && $route.name === 'dashboard'
                    "
                    class="-left"
                    >{{ title }}</ion-title
                >
                <ion-title size="small" v-else-if="$store.state.baseurl">{{
                    $store.state.baseurl
                }}</ion-title>
                <div slot="end" class="c-mini-stepper" v-if="showMiniStepper">
                    <ion-text color="dark"
                        >{{ step }} von {{ stepCount }}</ion-text
                    >
                    <ion-progress-bar
                        :value="step / stepCount"
                    ></ion-progress-bar>
                </div>
                <ion-buttons slot="end">
                    <ion-button
                        color="dark"
                        v-if="$store.state.nativeEnvironment === 'development'"
                        @click="openDevelopmentSettings()"
                    >
                        <ion-icon name="hammer"></ion-icon>
                    </ion-button>
                    <ion-button
                        color="dark"
                        style="height: auto;"
                        @click="$router.push({ name: 'profil' })"
                        v-if="$store.state.isLoggedIn"
                    >
                        <!-- <span v-if="$route.name === 'dashboard'">{{
                            title
                        }}</span> -->
                        <div class="c-klickmal-logo">
                            <span class="icon-kamel"></span>
                        </div>
                        <!-- <ion-icon class="c-klickmal-logo" name="person"></ion-icon>slot="icon-only" -->
                    </ion-button>
                </ion-buttons>
            </ion-toolbar>
            <transition name="fade">
                <loading-bar
                    v-if="
                        $store.state.loadingCount > 0 && !$store.state.loading
                    "
                ></loading-bar>
            </transition>
        </ion-header>
        <ion-content
            :fullscreen="!hasFooterSlot"
            class="ion-padding"
            ref="content"
            :class="{ 'no-padding': noPadding }"
        >
            <slot></slot>
            <!-- <ion-fab
                vertical="bottom"
                horizontal="end"
                slot="fixed"
                v-if="showDokboxFab"
            >
                <ion-fab-button @click="openDokboxModal()">
                    <ion-icon name="add"></ion-icon>
                </ion-fab-button>
            </ion-fab> -->
        </ion-content>
        <!-- <ion-footer
            no-border
            v-if="
                !$store.state.isLoggedIn &&
                ($route.name === 'dashboard' ||
                    $route.name === 'schadensmeldung' ||
                    $route.name === 'schadensmeldung-neu')
            "
        >
            <ion-toolbar>
                <ion-button
                    expand="block"
                    @click="$router.push({ name: 'login' })"
                    >Login</ion-button
                >
            </ion-toolbar>
        </ion-footer> -->
        <ion-footer no-border v-if="hasFooterSlot">
            <ion-toolbar>
                <slot name="footer"></slot>
            </ion-toolbar>
        </ion-footer>
    </ion-page>
</template>

<script>
import LoadingBar from "./LoadingBar";
// import { logout } from "@/api/auth";
import DokboxModal from "@/components/DokboxModal";
import DevelopmentSettingsModal from "@/components/DevelopmentSettingsModal";

export default {
    components: {
        LoadingBar,
    },
    data() {
        return {
            historyLength: 0,
            capacitor: Capacitor,
        };
    },
    props: {
        step: {
            type: Number,
            required: false,
        },
        stepCount: {
            type: Number,
            required: false,
        },
        showMiniStepper: {
            type: Boolean,
            required: false,
            default: false,
        },
        showBackButton: {
            type: Boolean,
            default: false,
        },
        defaultHref: {
            type: String,
            default: "/dashboard",
        },
        showDashboardButton: {
            type: Boolean,
            default: false,
        },
        showDokboxFab: {
            type: Boolean,
            default: false,
            required: false,
        },
        noPadding: {
            type: Boolean,
            required: false,
            default: false,
        },
        showStepBackButton: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    mounted() {
        this.historyLength = window.history.length;
    },
    computed: {
        title() {
            let result = "";
            if ("vorname" in this.$store.state.user.details) {
                result = "Hallo " + this.$store.state.user.details.vorname;
            }
            return result;
        },
        hasFooterSlot() {
            let result = false;
            if (
                this.$slots.hasOwnProperty("footer") &&
                this.$slots.footer.length > 0
            ) {
                result = true;
            }
            return result;
        },
    },
    methods: {
        openDevelopmentSettings() {
            this.$ionic.modalController
                .create({
                    component: DevelopmentSettingsModal,
                    componentProps: {
                        propsData: {},
                        parent: this,
                    },
                    backdropDismiss: true,
                })
                .then((m) => m.present());
        },
        openDokboxModal() {
            this.$ionic.modalController
                .create({
                    component: DokboxModal,
                    componentProps: {
                        propsData: {},
                        parent: this,
                    },
                    backdropDismiss: false,
                })
                .then((m) => m.present());
        },
        scrollToTop() {
            this.$refs.content.scrollToTop();
        },
    },
    // logout() {
    //   this.$store.commit("setLoading", true);
    //   logout();
    // }
};
</script>

<style lang="scss" scoped>
.c-mini-stepper {
    width: 80px;
}

.c-klickmal-logo {
    border: solid 1px var(--ion-color-dark);
    border-radius: 100px;
    // margin-left: 10px;
    padding: 6px;
    font-size: 24px;
    // line-height: 1;
    width: 39px;
    height: 39px;
}

ion-title.ios.-left {
    padding: 0;
    left: var(--ion-padding, 16px);
    width: auto;
    font-weight: normal;
}

// ion-footer {
//     padding-left: var(--ion-padding, 16px);
//     padding-right: var(--ion-padding, 16px);
//     // padding-left: var(--gangl-padding-small);
//     // padding-right: var(--gangl-padding-small);

//     ion-toolbar {
//         --background: none;

//         ion-button {
//             margin-left: 0;
//             margin-right: 0;
//         }
//     }
// }

.no-padding {
    --padding-start: 0;
    --padding-end: 0;
}

ion-back-button {
    --padding-start: 11px;
    --padding-end: 11px;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}
.fade-enter-active {
    transition-delay: 0.3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
</style>
